class DateUtils {

  /**
   * Check if a given timestamp or datea is today or later
   * @param {*} date The date to check (can be a date object or a timestamp)
   * @returns Returns true if the given date is today or later, false if not
   */
  static dateIsTodayOrLater(date) {
    const today = new Date();
    const dateToCheck = new Date(date);

    const todayDateOnly = new Date(today.toDateString());
    const dateToCheckDateOnly = new Date(dateToCheck.toDateString());

    return dateToCheckDateOnly >= todayDateOnly;
  }

}

export default DateUtils;